const ADVANCED_FILTERS_TYPES = {
  option: 'option',
  value: 'value',
  empty: 'empty',
  isNot: 'no_is',
  is: 'is',
  isToday: 'is_today',
  thisMonth: 'this_month',
  lastMonth: 'last_month',
  isAfterOrEqualToday: 'is_after_or_equal_today',
  isBeforeOrEqualToday: 'is_before_or_equal_today',
  notEmpty: 'no_empty',
  isBetween: 'between',
  contains: 'contains',
  notContains: 'not_contains',
} as const

export default ADVANCED_FILTERS_TYPES
